import { apiFetch } from '../api';

let usuario = null;
// ~26 componentes (cada pantalla + navbar + header) llaman fetchUsuario() en su propio
// useEffect al montar; sin esto, una sola navegación disparaba hasta 9 GET /api/me, varios
// en paralelo y otros en ráfaga corta (hallazgo UX-16 de la ronda 6 de QA). Dos capas:
// 1) mientras haya una petición en vuelo, todas la reutilizan (mismo patrón que
//    refreshPromise en api.js); 2) una caché corta evita repetir la llamada para los montajes
//    que no alcanzan a solaparse con la primera petición.
// ponytail: 3s es a propósito corto — si algún flujo cambia el perfil del usuario y necesita
// el dato fresco de inmediato (no solo en la próxima navegación), tendría que forzar un
// fetch propio en vez de depender de este caché.
let fetchPromise = null;
let ultimoFetchTs = 0;
const CACHE_MS = 3000;

export const fetchUsuario = async () => {
    if (fetchPromise) return fetchPromise;
    if (usuario && Date.now() - ultimoFetchTs < CACHE_MS) return usuario;
    fetchPromise = fetchUsuarioAhora().finally(() => { fetchPromise = null; });
    return fetchPromise;
};

const fetchUsuarioAhora = async () => {
    try {
        // Migrado: antes userLogued.php con cookie; ahora /api/me con Bearer token.
        const data = await apiFetch('/me');

        // Normalizar arrays - asegurar que siempre sean arrays
        if (!Array.isArray(data.categorias)) {
            data.categorias = data.categorias || [];
        }
        if (!Array.isArray(data.servicios)) {
            data.servicios = data.servicios || [];
        }

        // Normalizar idCategorias e idServicios
        if (!Array.isArray(data.idCategorias)) {
            if (data.idCategorias && typeof data.idCategorias === 'string') {
                data.idCategorias = data.idCategorias.split(',').map(id => parseInt(id));
            } else if (data.idCategoria) {
                data.idCategorias = [parseInt(data.idCategoria)];
            } else {
                data.idCategorias = data.categorias.map(c => parseInt(c.idCategoria));
            }
        }

        if (!Array.isArray(data.idServicios)) {
            if (data.idServicios && typeof data.idServicios === 'string') {
                data.idServicios = data.idServicios.split(',').map(id => parseInt(id));
            } else if (data.idServicio) {
                data.idServicios = [parseInt(data.idServicio)];
            } else {
                data.idServicios = data.servicios.map(s => parseInt(s.idServicio));
            }
        }

        // Helper: obtener Ceseco principal
        data.getCesecoPrincipal = () => {
            return data.cesecoPrincipal ||
                   data.categorias.find(c => c.esPrincipal === 1 || c.esPrincipal === '1') ||
                   (data.categorias.length > 0 ? data.categorias[0] : null);
        };

        // Helper: obtener Servicio principal
        data.getServicioPrincipal = () => {
            return data.servicioPrincipal ||
                   data.servicios.find(s => s.esPrincipal === 1 || s.esPrincipal === '1') ||
                   (data.servicios.length > 0 ? data.servicios[0] : null);
        };

        // Helper: verificar si tiene acceso a un Ceseco
        data.tieneAccesoACeseco = (idCategoria) => {
            if (['admin', 'direccion'].includes(data.rol)) return true;
            const idCat = parseInt(idCategoria);
            return data.idCategorias && data.idCategorias.includes(idCat);
        };

        // Helper: verificar si tiene acceso a un Servicio
        data.tieneAccesoAServicio = (idServicio) => {
            if (['admin', 'direccion'].includes(data.rol)) return true;
            const idServ = parseInt(idServicio);
            return data.idServicios && data.idServicios.includes(idServ);
        };

        // Helper: obtener todos los Cesecos asignados (nombres)
        data.getCesecosAsignados = () => {
            return data.categorias.map(c => c.categoria);
        };

        // Helper: obtener todos los Servicios asignados (títulos)
        data.getServiciosAsignados = () => {
            return data.servicios.map(s => s.titulo);
        };

        usuario = data;
        ultimoFetchTs = Date.now();
    } catch (error) {
        console.error('Error al obtener datos del usuario:', error);
        usuario = null;
    }
};

// Nota: se quitó el mock de localhost — ahora localhost usa el login real contra Laravel
// (token en localStorage). Si necesitas el mock para desarrollo sin backend, restáuralo aquí.
export const getUsuario = () => usuario;
